globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalMain = (function(superClass) {
  globalThis.utils.extend(ModalMain, superClass);

  function ModalMain($html) {
    return ModalMain.__super__.constructor.apply(this, arguments);
  }

  ModalMain.NAMESPACE = backoffice;

  ModalMain.prototype.init = function() {
    var $input;

    this.$html.on('hidden.bs.modal', (function(_this) {
      return function() {
        return _this.close();
      };
    })(this));

    this.$html.find('button.submit').click((function(_this) {
      return function() {
        backoffice.loader.start();
        _this.submit();
        return false;
      };
    })(this));

    this.$html.find("[data-popup=tooltip]").tooltip();

    return ModalMain.__super__.init.apply(this, arguments);
  };

  ModalMain.prototype.close = function() {
    if (this.getLevel() > 1) {
      $('body').addClass('modal-open');
    }

    this.$html.modal('hide');

    backoffice.loader.finish();

    return ModalMain.__super__.close.apply(this, arguments);
  };

  ModalMain.prototype.updateView = function(response, callback) {
    var $target, $view;

    if (response.html != null) {
      $view = $(response.html);

      if (this.$html.data('target')) {
        $target = $(this.$html.data('target'));
      }

      if ($target) {
        $target.replaceWith($view);
      }

      if (callback instanceof Function) {
        return callback($view);
      }
    }
  };

  ModalMain.prototype.openLoader = function() {
    var $loader = $('<div class="loader-wrapper">' +
                      '<div class="loader text-teal-400">' +
                        '<i class="icon-spinner9 spinner"></i>' +
                      '</div>' +
                    '</div>'
                    )
    this.$html.find(".modal-content").append($loader);
  }

  ModalMain.prototype.closeLoader = function() {
    this.$html.find(".loader-wrapper").remove();
  }

  return ModalMain;

})(globalThis.Modal);

globalThis.Modal = backoffice.ModalMain;

globalThis.ModalOpener.NAMESPACE = '/ajax';
